import { Component, Mixins, Prop } from 'vue-property-decorator';
import { HorizontalBar } from 'vue-chartjs';
import { BarChartDatasetInterface } from '@/services/QC-V2/statistic/interfaces';

@Component({})
export default class HorizontalBarChart extends Mixins(HorizontalBar) {
  @Prop() private title!: string;
  @Prop() private footerText!: string;
  @Prop() private dataset!: BarChartDatasetInterface;

  public mounted(): void {
    this.createChart();
  }

  private createChart(): void {
    this.renderChart({
        labels: this.dataset.labels,
        datasets: [{
          data: this.dataset.data,
          borderColor: this.dataset.borderColor,
          backgroundColor: this.dataset.backgroundColor,
        }],
      },
      {
        legend: {
          display: false,
        },
        responsive: true,
        title: {
          text: this.title,
          display: true,
        },
        elements: {
          point: {
            radius: 5,
            pointStyle: 'circle',
            hitRadius: 100,
          },
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: 'Count',
              },
              ticks: {
                beginAtZero: true,
                stepSize: 1,
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: this.footerText || '',
              },
              ticks: {
                beginAtZero: true,
                stepSize: 1,
              },
            },
          ],
        },
      },
    );
  }
}
